import workspaceQuery from '../../queries/nominal/NominalWarehouseAccountSetWorkspaceQuery.graphql';
import listQuery from '../../queries/nominal/NominalWarehouseAccountSetListQuery.graphql';
import instanceQuery from '../../queries/nominal/NominalWarehouseAccountSetQuery.graphql';
import defaultQuery from '../../queries/nominal/NominalWarehouseAccountSetDefault.graphql';
import mutationQuery from '../../mutations/nominal/NominalWarehouseAccountSetMutation.graphql';
import fragment from '../../fragments/nominal/NominalWarehouseAccountSetFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';

const NominalWarehouseAccountSet: EntityType = {
  type: 'NominalWarehouseAccountSet',
  title: 'Warehouse Account Sets',
  formTitle: 'Nominal Warehouse Account Set',
  formUrl: '/Nominal/WarehouseAccountSet/Details/',
  workspaceUrl: '/Nominal/WarehouseAccountSet/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'code',
  },
  fragment,
  screenReference: 'NOMINAL_WAREHOUSE_ACCOUNT_SET',
};

export default NominalWarehouseAccountSet;
